import develop_cart_content from "./utils/develop-cart-content.js";

const init = () => {
    develop_cart_content();
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});